(function () {
  const STORAGE_KEY = 'or_route_list_v1';
  const EVENT_NAME = 'or:wishlist:updated';
  const DEFAULT_STATE = { version: 1, items: [], updated_at: null };

  const parseState = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { ...DEFAULT_STATE };
      const parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.items)) return { ...DEFAULT_STATE };
      return {
        version: 1,
        items: parsed.items.filter((item) => item && item.variant_id),
        updated_at: parsed.updated_at || null,
      };
    } catch (error) {
      return { ...DEFAULT_STATE };
    }
  };

  const saveState = (state) => {
    const nextState = {
      version: 1,
      items: dedupeItems(state.items || []),
      updated_at: new Date().toISOString(),
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: nextState }));
    return nextState;
  };

  const dedupeItems = (items) => {
    const map = new Map();
    items.forEach((item) => {
      if (!item || !item.variant_id) return;
      const existing = map.get(String(item.variant_id));
      if (!existing) {
        map.set(String(item.variant_id), item);
        return;
      }
      map.set(String(item.variant_id), {
        ...existing,
        ...item,
        added_at: existing.added_at || item.added_at,
      });
    });
    return Array.from(map.values());
  };

  const getCurrentVariantId = (button) => {
    if (button.dataset.context !== 'pdp') return button.dataset.variantId;
    const formId = button.closest('.product__info-container')?.querySelector('product-form form')?.id;
    const input = formId
      ? document.querySelector(`form#${CSS.escape(formId)} [name="id"]`)
      : document.querySelector('product-form form [name="id"]');
    return input?.value || button.dataset.variantId;
  };

  const itemFromButton = (button) => {
    const variantId = getCurrentVariantId(button);
    const variantData = window.ORAnalyticsData?.productVariants?.[variantId];
    const currencyCode = window.ORAnalyticsData?.config?.currencyCode || 'CLP';
    const price = variantData ? Math.round(Number(variantData.price || 0) * 100) : Number(button.dataset.price || 0);
    return {
      product_id: button.dataset.productId || '',
      variant_id: variantId || '',
      handle: button.dataset.handle || '',
      title: button.dataset.title || '',
      vendor: button.dataset.vendor || '',
      url: button.dataset.url || '',
      image: button.dataset.image || '',
      price,
      price_formatted: variantData ? formatMoney(price, currencyCode) : button.dataset.priceFormatted || '',
      added_at: new Date().toISOString(),
    };
  };

  const formatMoney = (cents, currencyCode) => {
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 0,
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '';
    }
  };

  const hasVariant = (state, variantId) => state.items.some((item) => String(item.variant_id) === String(variantId));

  const syncButtons = () => {
    const state = parseState();
    document.querySelectorAll('[data-or-wishlist-toggle]').forEach((button) => {
      const variantId = getCurrentVariantId(button);
      const active = hasVariant(state, variantId);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = button.querySelector('.or-wishlist-button__label');
      if (label) {
        label.textContent = active ? label.dataset.labelActive || 'Guardado' : label.dataset.labelDefault || 'Guardar';
      }
    });
    document.querySelectorAll('[data-or-wishlist-count]').forEach((node) => {
      node.textContent = String(state.items.length);
      node.hidden = state.items.length === 0;
    });
  };

  const toggleItem = (button) => {
    const state = parseState();
    const item = itemFromButton(button);
    if (!item.variant_id) return;
    const active = hasVariant(state, item.variant_id);
    const items = active
      ? state.items.filter((stateItem) => String(stateItem.variant_id) !== String(item.variant_id))
      : [item, ...state.items];
    saveState({ ...state, items });
    renderRouteList();
    syncButtons();
  };

  const removeItem = (variantId) => {
    const state = parseState();
    saveState({
      ...state,
      items: state.items.filter((item) => String(item.variant_id) !== String(variantId)),
    });
    renderRouteList();
    syncButtons();
  };

  const addAllToCart = async () => {
    const state = parseState();
    if (!state.items.length || !window.routes?.cart_add_url) return;
    const button = document.querySelector('[data-or-wishlist-add-all]');
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: state.items.map((item) => ({ id: Number(item.variant_id), quantity: 1 })),
        }),
      });
      window.location.href = window.routes.cart_url || '/cart';
    } catch (error) {
      if (button) button.removeAttribute('aria-busy');
      window.alert('No se pudo agregar la lista al carrito.');
    }
  };

  const shareList = () => {
    const state = parseState();
    const lines = state.items.map((item) => `- ${item.title}: ${window.location.origin}${item.url}`);
    const text = ['Mi lista de ruta Overland Riders:', ...lines].join('\n');
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const cardTemplate = (item) => `
    <article class="or-route-item">
      <a class="or-route-item__media" href="${item.url}">
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
      </a>
      <div class="or-route-item__body">
        ${item.vendor ? `<div class="or-route-item__vendor">${escapeHtml(item.vendor)}</div>` : ''}
        <h2 class="or-route-item__title">${escapeHtml(item.title)}</h2>
        <div class="or-route-item__price">${escapeHtml(item.price_formatted || '')}</div>
        <div class="or-route-item__footer">
          <button class="or-route-item__button" type="button" data-or-wishlist-add="${item.variant_id}">Agregar al carrito</button>
          <button class="or-route-item__remove" type="button" data-or-wishlist-remove="${item.variant_id}">Quitar de mi lista</button>
        </div>
      </div>
    </article>
  `;

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char]);

  const renderRouteList = () => {
    const root = document.querySelector('[data-or-wishlist-page]');
    if (!root) return;
    const state = parseState();
    const grid = root.querySelector('[data-or-wishlist-grid]');
    const empty = root.querySelector('[data-or-wishlist-empty]');
    const filled = root.querySelector('[data-or-wishlist-filled]');
    if (grid) {
      grid.innerHTML = state.items.map((item) => `<div class="or-route-list__item">${cardTemplate(item)}</div>`).join('');
    }
    if (empty) empty.hidden = state.items.length > 0;
    if (filled) filled.hidden = state.items.length === 0;
  };

  const addSingleToCart = async (variantId) => {
    if (!variantId || !window.routes?.cart_add_url) return;
    try {
      await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      window.location.href = window.routes.cart_url || '/cart';
    } catch (error) {
      window.alert('No se pudo agregar el producto al carrito.');
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-or-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(toggle);
      return;
    }

    const remove = event.target.closest('[data-or-wishlist-remove]');
    if (remove) {
      removeItem(remove.dataset.orWishlistRemove);
      return;
    }

    const add = event.target.closest('[data-or-wishlist-add]');
    if (add) {
      addSingleToCart(add.dataset.orWishlistAdd);
      return;
    }

    if (event.target.closest('[data-or-wishlist-add-all]')) {
      addAllToCart();
      return;
    }

    if (event.target.closest('[data-or-wishlist-share]')) {
      shareList();
    }
  });

  window.addEventListener(EVENT_NAME, syncButtons);
  document.addEventListener('change', (event) => {
    if (event.target.matches('product-form form [name="id"], product-info [name="id"]')) {
      window.requestAnimationFrame(syncButtons);
    }
  });
  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    renderRouteList();
  });
  document.addEventListener('variant:change', syncButtons);
})();
